export const CONTACTS_CARD_WIDTH = 255;
export const CONTACTS_CARD_HEIGHT = 130;
